const root = 'planUpgradeModal'
const billingInformationForm = `${root}-billingInformationForm`

export const TestId = {
  root,
  title: `${root}-title`,
  yearlyTile: `${root}-yearlyTile`,
  monthlyTile: `${root}-monthlyTile`,
  billingInformationForm,
  firstName: `${billingInformationForm}-firstName`,
  lastName: `${billingInformationForm}-lastName`,
  streetAddress: `${billingInformationForm}-streetAddress`,
  suite: `${billingInformationForm}-suite`,
  city: `${billingInformationForm}-city`,
  state: `${billingInformationForm}-state`,
  zipCode: `${billingInformationForm}-zipCode`,
  countrySelect: `${billingInformationForm}-countrySelect`,
  paymentDetails: `${billingInformationForm}-paymentDetails`,
  cancelButton: `${root}-cancelButton`,
  purchasePlanButton: `${billingInformationForm}-purchasePlanButton`,
  dismissModalButton: `${root}-dismissModalButton`,
  paymentReceivedAlert: 'paymentUpgradeModal-paymentReceivedAlert',
}
